// Даты отчёта. Все вычисления в UTC над календарными датами YYYY-MM-DD, без
// часовых поясов: какая дата «сегодня», решает projectToday по поясу проекта.
// Логика периодов повторяет бэкенд (services/chisai/GCB2/businessPulseReport/v2.ts),
// чтобы подписи периодов были верными ещё до ответа сервера.

const DAY = 86400000

export const parseDate = value => (value instanceof Date ? value : new Date(`${value}T00:00:00Z`))
export const iso = date =>
    parseDate(date)
        .toISOString()
        .slice(0, 10)
export const addDays = (date, amount) => new Date(+parseDate(date) + amount * DAY)
export const monthStart = (date, shift = 0) => {
    const d = parseDate(date)
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + shift, 1))
}
export const monthEnd = (date, shift = 0) => {
    const d = parseDate(date)
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + shift + 1, 0))
}
export const days = range => Math.round((parseDate(range.end) - parseDate(range.start)) / DAY) + 1

export const fmtDate = date => {
    const d = parseDate(date)
    return `${String(d.getUTCDate()).padStart(2, '0')}.${String(d.getUTCMonth() + 1).padStart(
        2,
        '0'
    )}.${String(d.getUTCFullYear()).slice(-2)}`
}
export const interval = range => `${fmtDate(range.start)} — ${fmtDate(range.end)}`
export const fromTo = range => `с ${fmtDate(range.start)} по ${fmtDate(range.end)}`

const PRESET_MONTHS = { quarter: 3, half: 6, year: 12 }

/** День — сегодня; неделя — текущая пн–вс; месяц — текущий; 3/6/12 месяцев — предыдущие полные месяцы. */
export function presetRange(preset, today) {
    const t = parseDate(today)
    if (preset === 'day') return { start: iso(t), end: iso(t) }
    if (preset === 'week') {
        const start = addDays(t, -((t.getUTCDay() + 6) % 7))
        return { start: iso(start), end: iso(addDays(start, 6)) }
    }
    if (preset === 'month') return { start: iso(monthStart(t)), end: iso(monthEnd(t)) }
    const months = PRESET_MONTHS[preset]
    return { start: iso(monthStart(t, -months)), end: iso(monthEnd(t, -1)) }
}

function fullMonths(range) {
    const start = parseDate(range.start)
    const end = parseDate(range.end)
    if (start.getUTCDate() !== 1 || iso(end) !== iso(monthEnd(end))) return 0
    return (end.getUTCFullYear() - start.getUTCFullYear()) * 12 + end.getUTCMonth() - start.getUTCMonth() + 1
}

/** Соседний период той же длины прямо перед выбранным; для полных месяцев — те же месяцы назад. */
export function adjacentRange(range) {
    const months = fullMonths(range)
    const start = parseDate(range.start)
    return {
        start: iso(months ? monthStart(start, -months) : addDays(start, -days(range))),
        end: iso(addDays(start, -1)),
    }
}

function previousYear(value) {
    const d = parseDate(value)
    const year = d.getUTCFullYear() - 1
    const month = d.getUTCMonth()
    const last = new Date(Date.UTC(year, month + 1, 0)).getUTCDate()
    return iso(new Date(Date.UTC(year, month, Math.min(d.getUTCDate(), last))))
}

export function compareRange(range, comparison) {
    if (comparison === 'none') return null
    if (comparison === 'year') return { start: previousYear(range.start), end: previousYear(range.end) }
    return adjacentRange(range)
}

/** Сегодня по часам проекта. Поддерживает IANA-пояса и вид «UTC+3». */
export function projectToday(timezone, now = new Date()) {
    const offset = /^UTC([+-]\d{1,2})$/.exec(timezone || '')
    if (offset) return new Date(+now + Number(offset[1]) * 3600000).toISOString().slice(0, 10)
    try {
        const parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: timezone || 'Europe/Moscow',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).formatToParts(now)
        const part = type => parts.find(item => item.type === type).value
        return `${part('year')}-${part('month')}-${part('day')}`
    } catch (error) {
        return projectToday('Europe/Moscow', now)
    }
}
